import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiChevronLeft, FiMessageSquare, FiSettings, FiClock } from 'react-icons/fi';
import { ROUTES } from '../../app/routes';
import CarrierFinderChat from './CarrierFinderChat';
import CarrierFinderConfigure from './CarrierFinderConfigure';
import CarrierFinderHistory from './CarrierFinderHistory';
import '../commissionscan/CommissionScan.css';
import '../../styles/CarrierFinder.css';
type View = 'chat' | 'configure' | 'history';
export interface ChatMessage {
    chatId: string;
    question: string;
    answer: string;
}
interface ChatSession {
    conversationId: string;
    initialChats: ChatMessage[];
}
const newSession = (): ChatSession => ({
    conversationId: crypto.randomUUID(),
    initialChats: [],
});
const CarrierFinderPage: React.FC = () => {
    const navigate = useNavigate();
    const [view, setView] = useState<View>('chat');
    const [session, setSession] = useState<ChatSession>(newSession);
    const startNewChat = () => {
        setSession(newSession());
        setView('chat');
    };
    const loadConversation = (convId: string, chats: ChatMessage[]) => {
        setSession({ conversationId: convId, initialChats: chats });
        setView('chat');
    };
    return (<div className="cs-page">
      
      <div className="cs-sidebar">
        <button className="cs-back-link" onClick={() => navigate(ROUTES.MARKETPLACE)}>
          <FiChevronLeft size={14}/>
          Back to Marketplace
        </button>
        <nav className="cs-nav">
          <button className={`cs-nav__item${view === 'chat' ? ' cs-nav__item--active' : ''}`} onClick={startNewChat}>
            <FiMessageSquare size={15}/>
            New Chat
          </button>
          <button className={`cs-nav__item${view === 'configure' ? ' cs-nav__item--active' : ''}`} onClick={() => setView('configure')}>
            <FiSettings size={15}/>
            Configure
          </button>
          <button className={`cs-nav__item${view === 'history' ? ' cs-nav__item--active' : ''}`} onClick={() => setView('history')}>
            <FiClock size={15}/>
            History
          </button>
        </nav>
      </div>

      
      <div className={`cs-main${view === 'history' ? ' cs-main--history' : ''}`}>
        {view === 'history' ? (<CarrierFinderHistory onLoadConversation={loadConversation}/>) : view === 'configure' ? (<CarrierFinderConfigure />) : (<CarrierFinderChat key={session.conversationId} conversationId={session.conversationId} initialChats={session.initialChats} onGoToHistory={() => setView('history')} onGoToConfigure={() => setView('configure')}/>)}
      </div>
    </div>);
};
export default CarrierFinderPage;
